import React from "react";

export default ({className, ...props}) => (
  <div className={`layoutRow fxwWrap mh-5` + (className ? ` ${className}` : '')} {...props} />
);
